module.exports = __webpack_public_path__ + "media/images/lb/517-17e1ef7a467762b00ca220bf64edc414.svg";